<template>
    <div></div>
</template>

<script>
    /*
     * Developer Notes
     *
     * This page appears within an iframe inside /src/components/Checkout/PaymentDetails.vue
     * and is loaded after the user successfully verifies their account details via 3D Secure.
     *
     * This page simply posts a message to the parent window which takes the user to the
     * appointment confirmation screen.
     */
    export default {
        name: 'payment-successful',

        created() {
            window.parent.postMessage('payment.success', `${window.location.protocol}//${window.location.host}`);
        },
    }
</script>
